import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { LABELS, validHex } from "@/lib/theme/colors";

export default function ColorField({ token, value, onChange, flagged, testPrefix = "color" }) {
  const [text, setText] = useState(value);
  useEffect(() => setText(value), [value]);
  const id = `${testPrefix}-${token}`;
  const bad = !validHex(text);
  return (
    <div className="flex items-center gap-3 py-1.5" data-testid={`${testPrefix}-field-${token}`}>
      <input
        type="color"
        value={value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        aria-label={`${LABELS[token]} colour picker`}
        className="h-9 w-11 shrink-0 cursor-pointer rounded-md border border-le-input-border bg-le-surface p-0.5"
        data-testid={`${testPrefix}-swatch-${token}`}
      />
      <label htmlFor={id} className="flex-1 min-w-0 text-sm text-le-text">
        {LABELS[token]}
        {flagged && (
          <span className="ml-2 inline-flex items-center gap-1 text-xs font-medium text-amber-800" data-testid={`${testPrefix}-flag-${token}`}>
            <AlertTriangle className="h-3.5 w-3.5" aria-hidden /> Low contrast
          </span>
        )}
      </label>
      <Input
        id={id}
        value={text}
        maxLength={7}
        onChange={(e) => {
          const v = e.target.value.trim();
          setText(v);
          if (validHex(v)) onChange(v.toUpperCase());
        }}
        aria-invalid={bad}
        aria-describedby={bad ? `${id}-err` : undefined}
        className={cn("w-28 font-mono-num text-sm uppercase", bad && "border-red-600")}
        data-testid={`${testPrefix}-hex-${token}`}
      />
      {bad && <span id={`${id}-err`} className="sr-only">Enter a colour like #176B70</span>}
    </div>
  );
}
